import { DisputeDto } from "../api/models/disputes";
import { ApiDisputeDto } from "../api/models/api/disputes";

export const mapFromApiDisputeDto = (apiDto: ApiDisputeDto): DisputeDto => ({
    ...apiDto,
    id: apiDto.disputeId
});